/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://asrm43ftb6.execute-api.us-east-2.amazonaws.com/hyattplace",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://gtr2xnf4qnbnbor3oxp3ufysqi.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-asqjdcvr3nbofgmscqamiwtokm",
    "aws_cognito_identity_pool_id": "us-east-2:338658ef-c851-48fa-9fdc-723513687dcd",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_1Q9dWMwt0",
    "aws_user_pools_web_client_id": "3jkkn1kj46ck5662j9ll5hm4ad",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
